var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5008 20.943C17.4707 22.6933 14.8373 23.75 11.9597 23.75C5.53898 23.75 0.333984 18.4893 0.333984 12C0.333984 5.51065 5.53898 0.25 11.9597 0.25C14.8373 0.25 17.4707 1.30666 19.5008 3.05702C21.5309 1.30666 24.1643 0.25 27.0419 0.25C33.4625 0.25 38.6675 5.51065 38.6675 12C38.6675 18.4893 33.4625 23.75 27.0419 23.75C24.1643 23.75 21.5309 22.6933 19.5008 20.943Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 20.943C21.9996 18.7878 23.5846 15.581 23.5846 12C23.5846 8.41901 21.9996 5.21218 19.5 3.05701C21.5301 1.30666 24.1635 0.25 27.0411 0.25C33.4618 0.25 38.6668 5.51065 38.6668 12C38.6668 18.4893 33.4618 23.75 27.0411 23.75C24.1635 23.75 21.5301 22.6933 19.5 20.943Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5006 20.943C22.0002 18.7878 23.5852 15.581 23.5852 12C23.5852 8.41901 22.0002 5.21218 19.5006 3.05701C17.001 5.21218 15.416 8.41901 15.416 12C15.416 15.581 17.001 18.7878 19.5006 20.943Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.2af944604d084960fd77c0443fe953e2.svg";
export { ForwardRef as ReactComponent };